<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'FORM_POSTPROCESSORS', url: '/admin/form-postprocessors' },
    { label: 'UPDATE_POSTPROCESSOR' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_FORM_POSTPROCESSOR"></page-header>

<form-postprocessor-builder
  [isLoading]="isLoading"
  [data]="data"
  (onSubmit)="onSubmit($event)"
></form-postprocessor-builder>
